import { apiClient } from '@/services/ApiClient.js'

export default {
  getConditions(conditions) {
    return apiClient
      .get('financing-cost-rule/conditions', {
        params: conditions
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
